import { useContext, useEffect, useRef } from "react";
import { disableComponentInDev } from "../../utils/hoc/disableComponentInDev";
import { TrustPilotContext } from "../../utils/ctx/TrustPilotContext";

export const TrustPilotSmall = disableComponentInDev(() => {
  const ref = useRef(null);
  const { isTrustPilotLoaded } = useContext(TrustPilotContext);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [ref, isTrustPilotLoaded])

  if (typeof window === 'undefined') return null;

  return (
    <div className="flex py-12 px-4 lg:px-8 bg-gray">
      <div className="max-w-screen-2xl w-full mx-auto">
        <div ref={ref} className="trustpilot-widget p-7 lg:w-1/3 ml-auto bg-white" data-locale="es-ES" data-template-id="53aa8807dec7e10d38f59f32" data-businessunit-id="6271015447f748439a37e773" data-style-height="150px" data-style-width="100%" data-theme="light">
          <a className="no-animation" href="https://www.trustpilot.com/review/www.watchproject21.com" target="_blank" rel="noopener noreferrer">&nbsp;</a>
        </div>
      </div>
    </div>
  )
});

export const TrustPilotBig = disableComponentInDev(() => {
  const ref = useRef(null);
  const { isTrustPilotLoaded } = useContext(TrustPilotContext);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [ref, isTrustPilotLoaded])

  if (typeof window === 'undefined') return null;

  return (
    <div className="flex p-7 bg-gray pb-24">
      <div ref={ref} className="trustpilot-widget bg-white py-14 pl-16 pr-6 max-w-screen-2xl w-full mx-auto" data-locale="es-ES" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="6271015447f748439a37e773" data-style-height="20px" data-style-width="100%" data-theme="light">
        <a className="no-animation" href="https://www.trustpilot.com/review/www.watchproject21.com" target="_blank" rel="noopener noreferrer">&nbsp;</a>
      </div>
    </div>
  )
})
